/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import {
    addressTitleStyle,
    addressWrapper,
    editLink,
} from "@monsma/App/WidgetExtensions/Addresses/SharedAddressesComponentsStylesExtension";
import { currentShippingAddressStyles } from "@monsma/Overrides/Widgets/Addresses/CurrentShippingAddress";

currentShippingAddressStyles.xngStyles = {
    wrapper: addressWrapper,
};

currentShippingAddressStyles.headingText = addressTitleStyle;

currentShippingAddressStyles.editLink = editLink;
